import { Popover } from "@lockerpm/design";
import { BadgeV2 } from "./Badge";
import { ReactNode } from "react";

interface IBadgeSeeMoreV2Props {
  badges: ReactNode[];
}

export const BadgeSeeMoreV2 = ({ badges }: IBadgeSeeMoreV2Props) => {
  if (badges.length === 0) return null;

  return (
    <Popover
      placement="bottomLeft"
      content={
        <div className="flex gap-x-1 gap-y-2 max-w-[40rem] flex-wrap">
          {badges}
        </div>
      }
      trigger="hover"
    >
      <div>
        <BadgeV2 name={"+" + badges.length} color="gray" />
      </div>
    </Popover>
  );
};
